import React, { useEffect, useState } from 'react';
import './auth.styles.scss';

import Login from '../auth/components/forms/login/';
import ForgotPassword from '../auth/components/forgot-password';
import ForgotPasswordChange from '../auth/components/forgot-password-change';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '@lift-admin/utils/provider';
import { setLoggingOut } from '@lift-admin/utils';

const Auth = () => {
  const location = useLocation();
  const [userAction, setUserAction] = useState('login');
  const [email, setEmail] = useState('');

  useEffect(() => {
    setLoggingOut(false);
  }, []);

  useEffect(() => {
    setUserAction(location.state === null ? 'login' : location.state.action);
  }, [location.state]);

  const navigator = useNavigate();

  const { authUser } = useAuthContext();
  const super_admin = localStorage.getItem('super_admin')
    ? JSON.parse(localStorage.getItem('super_admin') || '')
    : null;

  useEffect(() => {
    if (authUser && super_admin) {
      navigator('/home');
    }
  }, [authUser, super_admin]);

  return (
    <>
      {userAction === 'login' ? (
        <Login changeUserAction={(ac: any) => setUserAction(ac)} />
      ) : userAction === 'forgot-pwd' ? (
        <ForgotPassword
          changeUserAction={(ac: any) => setUserAction(ac)}
          changeEmail={(e: any) => setEmail(e)}
        />
      ) : (
        <ForgotPasswordChange
          changeUserAction={(ac: any) => setUserAction(ac)}
          email={email}
        />
      )}
    </>
  );
};

export default Auth;
